module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0zLjk5OTAyIDE0LjAwMDNINy45OThWOS45OTkyNkgzLjk5OTAyVjE0LjAwMDNaTTMuOTk5MDIgMTlINy45OThWMTQuOTk5SDMuOTk5MDJWMTlaTTMuOTk5MDIgOS4wMDA1M0g3Ljk5OFY0Ljk5OTUxSDMuOTk5MDJWOS4wMDA1M1pNOS4wMDA4MSAxNC4wMDAzSDIwLjk5OThWOS45OTkyNkg5LjAwMDgxVjE0LjAwMDNaTTkuMDAwODEgMTlIMjAuOTk5OFYxNC45OTlIOS4wMDA4MVYxOVpNOS4wMDA4MSA0Ljk5OTUxVjguOTk4NDlIMjAuOTk5OFY0Ljk5OTUxSDkuMDAwODFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/navbar/tasks.svg
// module id = EEls
// module chunks = 1